import { VydejMenu } from '../../vydej/vydejmenu';
import { useParams } from 'react-router';

import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import { ServiceOrderDetail } from '../../serviceOrders/components/ServiceOrderDetail';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const VydejServiceOrderDetailPage = () => {
  const { apps, customerType } = useSelector((state) => state.app.config);
  const { id } = useParams<{ id: string }>();

  return (
    <>
      {apps?.vydej && customerType === 'ipr' && id ? (
        <AppWrapper
          appType={APP_TYPE.VYDEJ}
          menu={<VydejMenu />}
          resource='ServiceOrders'
          action='retrieve'
        >
          <ServiceOrderDetail serviceOrderId={id} />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejServiceOrderDetailPage;
